import { isWeb, isReactNative } from '../platform.js';
import { WebAuthStorage } from './WebStorage.js';
import { ReactNativeAuthStorage } from './ReactNativeStorage.js';

const createUniversalStorage = (options)=>{
    if (isWeb()) {
        return new WebAuthStorage(options);
    } else if (isReactNative()) {
        return new ReactNativeAuthStorage(options);
    } else {
        console.warn('Unknown platform, using WebAuthStorage as fallback');
        return new WebAuthStorage(options);
    }
};

export { createUniversalStorage };
//# sourceMappingURL=index.js.map
